import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from '@/store'
import '@/assets/tokens.css'
import '@/assets/global.css'

// Sincroniza a classe `theme-dark` no <html> com a preferência salva,
// antes de qualquer render, para evitar flash de tema errado.
try {
    const saved = localStorage.getItem('app-theme')
    if (saved === 'dark') {
        document.documentElement.classList.add('theme-dark')
    }
} catch (e) { /* ignore */ }

import VueApexCharts from 'vue-apexcharts'
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";

import { vMaska } from 'maska'
import './plugins/components'
import './plugins/globals'

Vue.config.productionTip = false
Vue.use(VueApexCharts)
Vue.component('ApexChart', VueApexCharts)
Vue.directive('maska', vMaska)
Vue.use(wysiwyg, {});

// register utils
require
    .context('./utils', false, /\.js$/)
    .keys()
    .forEach((key) => {
        require(`./utils/${key.split('/').pop()}`)
    })

const app = new Vue({
    router,
    vuetify,
    store,
    render: (h) => h(App),
})

app.$mount('#app')
